module.exports = __webpack_public_path__ + "static/media/muestra.53fbf0ea.svg";